module.exports = __webpack_public_path__ + "img/cattunnel22.2f516f91.jpg";